import React, { Component } from "react";
import AuthService from "../services/user_service";
import { toast } from 'react-toastify';

class CreateUserModal extends Component {
    state = {
        name: "",
        email: "",
        password: "",
        role: "2", // default user role
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };

    handleSave = () => {
        const { name, email, password, role } = this.state;

        if (!name || !email || !password || !role) {
            toast.error("Please fill all fields before saving.");
            return;
        }

        AuthService.signup({
            name,
            email,
            password,
            role: parseInt(role)
        })
        .then((response) => {
            if (response.data.success) {
                toast.success("File uploaded successfully");

                this.props.closeModal();
                window.location.reload();
            } else {
                toast.error(response.data.message || "Failed to create user");
            }
        })
        .catch((err) => {
            console.error(err);
            toast.error("Error while creating user");
        });
    };

    render() {
        const { name, email, password, role } = this.state;
        const { closeModal } = this.props;

        return (
            <div
                className="position-fixed top-0 start-0 w-100 h-100"
                style={{ background: "rgba(0,0,0,0.4)", zIndex: 9999 }}
            >
                <div
                    className="bg-white rounded shadow p-4 position-absolute"
                    style={{
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "90%",
                        maxWidth: "500px",
                    }}
                >
                    {/* Header */}
                    <div className="position-relative mb-4">
                        <h4 className="text-center fw-bold py-2">Create User</h4>

                        <button
                            className="btn position-absolute end-0 top-0 mt-1 me-2"
                            onClick={closeModal}
                            aria-label="Close"
                        >
                            <i className="bi bi-x-lg fs-4"></i>
                        </button>
                    </div>

                    {/* Input Fields */}
                    <div className="mb-3">
                        <label className="">Full Name</label>
                        <input
                            type="text"
                            className="form-control border-3 mt-2"
                            name="name"
                            value={name}
                            onChange={this.handleChange}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="">Email Address</label>
                        <input
                            type="email"
                            className="form-control border-3 mt-2"
                            name="email"
                            value={email}
                            onChange={this.handleChange}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="">Password</label>
                        <input
                            type="password"
                            className="form-control border-3 mt-2"
                            name="password"
                            value={password}
                            onChange={this.handleChange}
                        />
                    </div>

                    <div className="mb-3">
                        <label className="">Role</label>
                        <select
                            className="form-control border-3 mt-2"
                            name="role"
                            value={role}
                            onChange={this.handleChange}
                        >
                            <option value="1">Admin</option>
                            <option value="2">User</option>
                        </select>
                    </div>

                    {/* Buttons */}
                    <div className="d-flex justify-content-center gap-3 mt-4">
                        <button
                            className="btn btn-dark px-5 py-3"
                            style={{ background: "#193e6c" }}
                            onClick={this.handleSave}
                        >
                            Create &nbsp; →
                        </button>

                        <button
                            className="btn px-5 py-3 border-2"
                            style={{ border: "2px solid #193e6c" }}
                            onClick={closeModal}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateUserModal;
